import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { GenericPopupProps } from '@models/ui';
import { NavLink, useNavigate } from '@remix-run/react';
import { mixpanelService } from '@utilities';
import React, { useEffect, Fragment } from 'react';

const CommentsLoginPopUp: React.FC<GenericPopupProps> = ({ open, onClose }) => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem('position', 'reaction_books');
  }, []);

  const onLogin = () => {
    onClose();
    mixpanelService.track('login_cta_click', {
          position: 'video_library',
        });
    setTimeout(() => {
      navigate('/login');
    }, 100);
  };
  
  return (
    <Transition show={open} as={Fragment}>
      <Dialog className="relative z-10" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-40 transition-opacity" />
        </TransitionChild>

        <div className="fixed inset-0 z-10 w-screen ">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all">
                <div className="absolute right-0 top-0 block pt-2 pr-2">
                  <button
                    type="button"
                    // className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-8 w-8" aria-hidden="true" />
                  </button>
                </div>
                <div className="flex flex-col gap-y-4 px-9 py-9 items-center">
                  <div className="flex flex-col gap-y-3 items-center self-stretch justify-end">
                    <DialogTitle as="h3" className="w-[235px] text-center text-[24px] font-bold text-[#343434]">
                      You&apos;re not logged in!
                    </DialogTitle>
                    <p className="flex-1 self-stretch text-subtext font-medium text-center text-[#42526B]">
                      Oops! You need to log in to engage <br /> with books and comments. <br /> It takes less than a minute!
                    </p>
                    <NavLink className="header-start-assessment mt-2" to="/login" onClick={onLogin}>
                      Login
                    </NavLink>
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CommentsLoginPopUp;
